import React, { useRef } from 'react';
import AddIcon from '@assets/icons/red-add-icon.svg';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import Grid from '@mui/material/Grid2';
import { Box, Typography, TextField, IconButton, Button, Chip, Stack, Paper, } from '@mui/material';
import Select from 'react-select';
import DatePickerFielder from '../../DatePickerFielder/DatePickerFielder';
import { useLanguage } from 'Context/LanguageContext';
import { useSelector } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import TaskGroupStatusFormatter from '../../SmartTable/TaskGroupStatusFormatter';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import Loading from '~/FielderElements/Loading/Loading';

const GroupTaskInfo = (props) => {
  const lan = useLanguage();
  const user = useSelector(selectUser);
  const cbnoassign = useRef({});
  const cbagent = useRef({});
  const cbteam = useRef({});
  const cbpartner = useRef({});
  const CreateAgents = () =>
    props.selectedAgents.map((agent, i) => (
      <Chip
        key={`${agent.id}-chip`}
        label={`${agent.name} ${agent.lastName}`}
        onDelete={!props.editOnly ? () => props.removeAgent(i) : undefined}
        disabled={props.editOnly}
        variant="outlined"
        size="small"
        sx={{ mr: 1, mb: 1 }}
      />
    ));
  return (
    <>
      {props.tab === 'infoTaskGroup' && (
        <Grid container spacing={2} sx={{ px: 2 }}>
          {/* LEFT COLUMN */}
          <Grid size={{ xs: 12, md: 6 }}>
            {/* Id Custom + Status */}
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" className="small-popup-label">
                {lan.idCustomGroupTask}
              </Typography>

              <Grid container spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                <Grid size={5}>
                  <TextField
                    fullWidth
                    id="idCustomGroup-red-input"
                    name="idCustom"
                    value={props.idCustomGroup}
                    onChange={(e) => props.onTodoChange(e.target.value, 'idCustomGroupTask')}
                    inputProps={{ readOnly: props.editOnly }}
                  />
                </Grid>

                <Grid size="auto">
                  <Box
                    component="img"
                    src={redAlertIcon}
                    alt=""
                    id="idCustomGroup-alert-icon"
                    className="CreateTask-dir-desc-fieldContainer-icon"
                    sx={{ display: 'block' }}
                  />
                </Grid>

                <Grid size>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <TaskGroupStatusFormatter {...props} value={props.status} />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {/* Execution Date */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="caption" className="small-popup-label">
                {lan.executionDate}
              </Typography>

              <DatePickerFielder
                id="executionDate-red-input"
                selected={props.dateSelected}
                handleDate={props.handleProgramDate}
                minDate={new Date()}
                timeFormat="HH:mm"
                minTime={props.minTime}
                maxTime={new Date().setHours(23, 59)}
                dateFormat="dd/MM/yyyy h:mm aa"
                timeIntervals={30}
                classNamePicker="MyOperation-eschedule mt-1 text-left datePicker-zIndex"
                imgId="executionDate-alert-icon"
                classNameImg="CreateTask-dir-desc-fieldContainer-icon"
                readOnly={props.editOnly}
              />
            </Box>
            {/* Description */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="caption" className="small-popup-label">
                {lan.description}
              </Typography>

              <Grid container spacing={1} alignItems="flex-start" sx={{ mt: 0.5 }}>
                <Grid size>
                  <TextField
                    id="description-red-input"
                    fullWidth
                    multiline
                    minRows={3}
                    value={props.description}
                    onChange={(e) => props.onTodoChange(e.target.value, 'description')}
                    inputProps={{ readOnly: props.editOnly }}
                  />
                </Grid>
                <Grid size="auto" sx={{ pt: 1 }}>
                  <Box
                    component="img"
                    src={redAlertIcon}
                    alt=""
                    id="description-alert-icon"
                    className="CreateTask-dir-desc-fieldContainer-icon"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
          {/* RIGHT COLUMN */}
          <Grid size={{ xs: 12, md: 6 }}>
            {/* Name */}
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" className="small-popup-label">
                {lan.name}
              </Typography>

              <Grid container spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                <Grid size>
                  <TextField
                    id="name-red-input"
                    fullWidth
                    name="name"
                    value={props.name}
                    onChange={(e) => props.onTodoChange(e.target.value, 'name')}
                    inputProps={{ readOnly: props.editOnly }}
                  />
                </Grid>
                <Grid size="auto">
                  <Box
                    component="img"
                    src={redAlertIcon}
                    alt=""
                    id="name-alert-icon"
                    className="CreateTask-dir-desc-fieldContainer-icon"
                  />
                </Grid>
              </Grid>
            </Box>
            {/* Branch */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="caption" className="small-popup-label">
                {lan.branch}
              </Typography>

              <Box sx={{ mt: 1 }}>
                {props.showBranchSelect && (
                  <AsyncSearch
                    className="react-select__control full-width mb-3"
                    getOptions={props.getOptionsBranch}
                    defaultValue={props.selectedBranch}
                    onChange={(e) => props.setFieldBranch(e)}
                    label={lan.placeHolderBranch}
                    disabled={!props.isPartner ? props.editOnly : true}
                    lan={lan}
                    id="branch-AsyncSearch"
                    multiple={false}
                    showInitialOptions
                    getInitialOptions={() => props.getInitialOptionsBranch()}
                  />
                )}
              </Box>
            </Box>
          </Grid>
          {/* OPTIONS STRIP (scrollable) */}
          <Grid size={12}>
            <Box
              sx={{
                mt: 3,
                maxHeight: 300,
                overflowY: 'auto',
                overflowX: 'hidden',
                pr: 1,
              }}
            >
              <Grid container spacing={2}>
                {/* No Assign */}
                {props.dontShowToManager && !props.isPartner && (
                  <Grid size="auto">
                    <Paper
                      sx={{
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.2,
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input labelCheckbox d-none"
                        id="cbnoassign"
                        name="checkbox-no-assign"
                        ref={cbnoassign}
                        checked={props.showNoAssign}
                        onClick={props.checkNoAssing}
                        disabled={props.editOnly}
                        readOnly
                      />
                      <label htmlFor="cbnoassign" className="square-checkbox" />
                      <span className="tag">{lan.doNotAssign}</span>
                    </Paper>
                  </Grid>
                )}

                {/* Team */}
                {!props.isPartner && (
                  <Grid size={props.dontShowToManager ? 'auto' : 4}>
                    <Paper
                      sx={{
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.2,
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input labelCheckbox d-none"
                        id="cbteam"
                        name="cbteam"
                        ref={cbteam}
                        checked={props.showTeamSearch}
                        onClick={props.checkTeams}
                        disabled={props.editOnly}
                        readOnly
                      />
                      <label htmlFor="cbteam" className="square-checkbox" />
                      <span className="tag">{lan.team}</span>
                    </Paper>
                  </Grid>
                )}

                {/* Partner */}
                {((props.dontShowToManager && !props.isPartner) || props.isPartner) && (
                  <Grid size={!props.isPartner ? 'auto' : 4}>
                    <Paper
                      sx={{
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.2,
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input labelCheckbox d-none"
                        id="cbpartner"
                        name="cbpartner"
                        ref={cbpartner}
                        checked={props.showPartnerSearch}
                        onClick={props.checkPartner}
                        disabled={props.editOnly}
                        readOnly
                      />
                      <label htmlFor="cbpartner" className="square-checkbox" />
                      <span className="tag">{lan.partners}</span>
                    </Paper>
                  </Grid>
                )}

                {/* Agent */}
                {props.dontShowToManager && !props.isPartner && (
                  <Grid size="auto">
                    <Paper
                      sx={{
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.2,
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input labelCheckbox d-none"
                        id="cbagent"
                        name="cbagent"
                        ref={cbagent}
                        checked={props.showAgentSearch}
                        onClick={props.checkAgent}
                        disabled={props.editOnly}
                        readOnly
                      />
                      <label htmlFor="cbagent" className="square-checkbox" />
                      <span className="tag">{lan.agent}</span>
                    </Paper>
                  </Grid>
                )}
              </Grid>

              {/* Dynamic sections */}
              {props.showNoAssign && <Box sx={{ mb: 3 }} />}

              {props.showTeamSearch && (
                <Box sx={{ mt: 3, mb: 4 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                    {lan.addTeam}
                  </Typography>
                  <AsyncSearch
                    className="react-select__control full-width mb-3"
                    getOptions={props.getOptionsTeam}
                    defaultValue={props.selectedTeam}
                    onChange={(e) => props.setFieldTeam(e)}
                    disabled={props.editOnly}
                    label={lan.team}
                    lan={lan}
                    isDisabled={props.editOnly}
                    showInitialOptions
                    getInitialOptions={() => props.getInitialOptionsTeam()}
                  />
                </Box>
              )}

              {props.showPartnerSearch && (
                <Box sx={{ mt: 3, mb: 4 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                    {lan.addPartner}
                  </Typography>
                  <AsyncSearch
                    className="react-select__control full-width mb-3"
                    getOptions={props.getOptionsPartner}
                    onChange={(e) => props.handleOptionSelectedPartner(e)}
                    defaultValue={props.selectedPartner}
                    disabled={!props.isPartner ? props.editOnly : true}
                    lan={lan}
                    id="all-AsyncSearch"
                    showInitialOptions
                    getInitialOptions={() => props.getInitialOptionsPartner()}
                  />
                </Box>
              )}

              {(RoleUtils.isUserManager(user) || props.showAgentSearch) && (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                    {lan.addAgents}
                  </Typography>

                  {!props.activateLoadingManager ? (
                    <Grid container spacing={1} alignItems="center">
                      <Grid size={{ xs: 12, md: 10 }}>
                        <Select
                          className="full-width mb-3"
                          options={props.agentsSelectList}
                          onChange={(e) => props.setFieldAgent(e)}
                          placeholder={props.lan.placeHolderClient}
                          isDisabled={props.editOnly}
                          classNamePrefix="smart-select"
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton
                          aria-label="add-agent"
                          disabled={props.editOnly}
                          onClick={() => props.addAgent(props.agent)}
                          sx={{ ml: { md: 1 } }}
                        >
                          <Box component="img" src={AddIcon} alt={lan.searchBy} sx={{ width: 28, height: 28 }} />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ) : (
                    <Box sx={{ mt: 1, ml: 2 }}>
                      <Loading inline size="40px" thickness={1} />
                    </Box>
                  )}

                  <Stack direction="row" useFlexGap flexWrap="wrap" sx={{ ml: 1, mt: 1, mb: 3 }}>
                    <CreateAgents />
                  </Stack>
                </Box>
              )}

              {/* Footer hints + Submit */}
              <Box id="register-form-hint" className="Register-form-hint" sx={{ mt: 3 }}>
                <Typography variant="body2">*{lan.requiredFields}</Typography>
              </Box>

              {props.showSubmitButton && (
                <Box sx={{ my: 4, display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={props.handleDoActionUpdateTaskGroup}
                    className="create-client-modal-btnsave-size"
                  >
                    {lan.add}
                  </Button>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default GroupTaskInfo;
